export class TipoOrigem {
    id: number;    
    descricao: string;
}